<template>
  <table-wrapper>
    <table-row>
      <table-heading :cols="1">
        刪除
      </table-heading>
      <table-heading :cols="5">
        商品項目
      </table-heading>
      <table-heading :cols="2">
        數量
      </table-heading>
      <table-heading :cols="2">
        單價
      </table-heading>
      <table-heading :cols="2">
        小計
      </table-heading>
    </table-row>
    <template v-if="advertisements.length > 0">
      <table-row
        v-for="(ad, index) in advertisements"
        :key="ad.ad_id"
      >
        <table-data :cols="1">
          <check-input
            v-model="batchDelete"
            :value="ad.ad_id"
            type="checkbox"
            no-pl
            name="batch-delete-printing-item"
          />
        </table-data>
        <table-data :cols="5">
          {{ ad.ad_item }}
        </table-data>
        <table-data :cols="2">
          <form-select
            :default-value="ad.ad_quantity"
            :options="ad.ad_max_order_quantity | toN"
            name="ad-quantity"
            @change="selectedQuantity($event, index)"
          />
        </table-data>
        <table-data :cols="2">
          {{ ad.ad_unit_price }}
        </table-data>
        <table-data :cols="2">
          {{ ad.ad_unit_price * ad.ad_quantity }}
        </table-data>
      </table-row>
    </template>
    <table-row>
      <table-heading
        :cols="10"
        class="text-right text-primary"
        border-top
      >
        目前商品金額合計
      </table-heading>
      <table-heading
        :cols="2"
        border-top
      >
        {{ total }}
      </table-heading>
    </table-row>
  </table-wrapper>
</template>
<script>
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import FormSelect from '~components/common/form/Select'
import CheckInput from '~components/common/form/input/Check'
import { toN } from '~utils/filters'
export default {
  name: 'PrintAdvertisingSpreadsheet',
  components: {
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    FormSelect,
    CheckInput
  },
  filters: {
    toN
  },
  props: {
    advertisements: {
      type: Array,
      default: () => []
    },
    enrolledAds: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      ads: [],
      batchDelete: []
    }
  },
  computed: {
    total () {
      if (!this.ads) {
        return 0
      }
      return this.ads.reduce((accumulator, currentValue) => accumulator + (currentValue.ad_quantity * currentValue.ad_unit_price), 0)
    }
  },
  watch: {
    total (value) {
      this.$emit('ads:changed', {
        ads: this.ads.filter(ad => ad.ad_quantity),
        ad_charge_total: value
      })
    },
    advertisements (value) {
      this.ads = value
    },
    'enrolledAds.ads' (value) {
      this.updateEnrolledAds(value)
    }
  },
  created () {
    this.ads = this.advertisements
    if (Object.keys(this.enrolledAds).length > 0) {
      this.updateEnrolledAds(this.enrolledAds.ads)
    }
  },
  methods: {
    resetSpreadsheet () {
      this.batchDelete = this.ads.map(ad => ad.ad_id)
      this.batchDeleteItems()
    },
    selectedQuantity ({ value }, index) {
      this.ads.splice(index, 1, Object.assign({}, this.ads[index], {
        ad_quantity: value
      }))
    },
    updateEnrolledAds (ads) {
      if (!ads.length) {
        return false
      }
      ads.map(ad => {
        const adIndex = this.ads.findIndex(innerAd => innerAd.ad_id === ad.ad_id)
        if (adIndex > -1) {
          this.ads.splice(adIndex, 1, Object.assign({}, ad))
        }
      })
    },
    batchDeleteItems () {
      this.batchDelete.forEach(adId => {
        const adIndex = this.ads.findIndex(innerAd => innerAd.ad_id === adId)
        if (adIndex > -1) {
          this.ads.splice(adIndex, 1, Object.assign({}, this.ads[adIndex], {
            ad_quantity: ''
          }))
        }
      })
      this.batchDelete = []
    }
  }
}
</script>
